import React from "react";
import { StoryScene } from "../../../story/forestRescueStory";

type StoryPageProps = {
  scene: StoryScene;
  storyTitle: string;
};

export function StoryPage({ scene, storyTitle }: StoryPageProps) {
  return (
    <main className="story-page" aria-label={storyTitle}>
      <section className="story-illustration" aria-label="Story picture">
        <img className="story-image" src={scene.image} alt={`${storyTitle} ${scene.id}`} />
      </section>

      {scene.text && (
        <section className="story-panel">
          <div className="story-panel-content">
            <p className="story-narration">{scene.text}</p>
          </div>
        </section>
      )}
    </main>
  );
}
